"use client";

import { FlexColumnAlignJustifyCenter } from "@/components/Flex";
import { report } from "@/utils/analytics/logging";
import { themeColors } from "@/utils/themeColors";
import dayjs from "dayjs";
import { useEffect } from "react";

function cleanStackTrace(error) {
    if (!error.stack) return error.message;

    return error.stack
        .split("\n")
        .filter(line => line.includes("localhost") && !line.includes("node_modules")) // Keep relevant lines
        .map(line => line.replace(/\(http:\/\/localhost:\d+\/_next\/static\/chunks\/.+?:/, "(")) // Shorten paths
        .join("\n");
}

export default function ErrorPage({ error }: { error: Error }) {
    useEffect(() => {
        report(error, window.location.href);
    }, [error]);

    return (
        <FlexColumnAlignJustifyCenter
            style={{
                textAlign: "center",
                backgroundColor: themeColors.background,
                height: "calc(99vh - var(--navbar-height))",
                maxWidth: "66rem",
                margin: "auto",
            }}>
            <h1
                style={{ fontSize: "4rem", fontWeight: "500" }}
                data-testid="auto-id-bcdcdd4d-a394-430f-a26c-6e9a0383eaa3">
                Not Found <span
                style={{ color: "#999", fontSize: "0.65em" }}
                data-testid="auto-id-27143810-d939-4c1e-881a-ae9d91043346">Error 404</span>
            </h1>
            <blockquote
                style={{ fontSize: "2.8rem", fontStyle: "italic" }}
                data-testid="auto-id-6ac22423-0877-408f-991a-be6e607f69a1">
                <p
                    style={{ position: "relative" }}
                    data-testid="auto-id-51866daa-477b-4078-bcb8-5cb6099f01b2">
                    <span
                        style={{
                            color: "#999",
                            fontSize: "3em",
                            fontFamily: "Georgia, serif",
                            position: "absolute",
                            left: "-0.37em",
                            top: -20,
                        }}
                        data-testid="auto-id-707b466a-c6c4-4da4-8fb2-7ab1a2efeee6">
                        “
                    </span>
                    Knowt can do many things, but it cannot show you a webpage when it does not exist!
                </p>
                <figcaption
                    style={{ color: "#999", fontSize: "0.7em", marginTop: "2rem" }}
                    data-testid="auto-id-2abda6fd-b382-4044-b04d-3246bf690700">
                    — Albert Einstein
                </figcaption>
            </blockquote>
            {/* show error information so it can be easily sent in a screenshot */}
            <div
                style={{ color: "#999" }}
                data-testid="auto-id-1b63d187-059f-4113-b95e-b7f4e50bf00a">
                <div data-testid="auto-id-a113b29d-e3a0-42b5-ad03-6f65f6c4c657">Error: {error.message}</div>
                <div data-testid="auto-id-1dba0013-d349-4d32-8622-45ae0aed9670">Stack: {cleanStackTrace(error)}</div>
                <div data-testid="auto-id-e870441c-3238-493d-817b-7b45f18170ad">Location: {window.location.href}</div>
                <div data-testid="auto-id-2a8e9b94-3d2a-4888-b0eb-a1f2e4a6486b">Timestamp: {dayjs().format("YYYY-MM-DD HH:mm:ss A Z")}</div>
            </div>
            <footer
                style={{ color: "#999", position: "fixed", bottom: 0, margin: "1rem" }}
                data-testid="auto-id-150d8ec0-5243-4406-8725-24d7cac438ea">
                Technical Contact:{" "}
                <a
                    style={{ color: themeColors.neutralBlack, textDecoration: "none" }}
                    href="mailto:contact@knowt.com"
                    data-testid="auto-id-1292a26c-2575-4ce4-9807-358496efa833">
                    contact@knowt.com
                </a>
            </footer>
        </FlexColumnAlignJustifyCenter>
    );
}
